import { z } from "zod";
export var idNamePairSchema = z.object({
    id: z.string(),
    name: z.string()
});
export var inspectorSchema = z.object({
    user: idNamePairSchema,
    hasStarted: z.boolean(),
    hasSigned: z.boolean(),
    hasFinished: z.boolean()
});
export var inspectionItemStatusSchema = z.object({
    value: z.string(),
    hasIssues: z.boolean()
});
export var inspectionItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    status: inspectionItemStatusSchema,
    inspectionItemTemplateId: z.string(),
    issueId: z.string()
});
export var inspectionStatusSchema = z.union([z.literal("ToDo"), z.literal("Ongoing"), z.literal("Approved"), z.literal("ApprovedWithRemarks"), z.literal("NotApproved"), z.literal("Cancelled"), z.literal("Overdue")]);
export var inspectionReportStatusSchema = z.union([z.literal("None"), z.literal("Initialized"), z.literal("Completeted"), z.literal("Error")]);
export var inspectionItemGroupSchema = z.object({
    inspectionItems: z.array(inspectionItemSchema)
});
var metadataSchema = z.object({
    valueType: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
    metadataElementId: z.string(),
    valueId: z.string().optional().nullable()
});
export var onSitePropertySchema = z.object({
    propertyId: z.string(),
    version: z.number(),
    startNode: z.string(),
    filterComponents: z.array(z.string()).nullable()
});
export var inspectionDocumentSchema = z.object({
    id: z.string(),
    name: z.string(),
    currentDocumentVersionId: z.string(),
    versionIds: z.array(z.string()),
    createdDate: z.string(),
    metadata: z.array(metadataSchema)
});
export var onSiteStructureSchema = z.lazy(function () { return z.object({
    id: z.string(),
    propertyId: z.string(),
    parentStructureId: z.string(),
    name: z.string(),
    component: z.string(),
    sortOrder: z.number(),
    hasChangesToPublish: z.boolean(),
    isDeleted: z.boolean(),
    path: z.string(),
    documentVersions: z.array(z.object({
        id: z.string(),
        name: z.string().nullable()
    })).optional().nullable(),
    metadata: z.array(metadataSchema).nullable(),
    structures: z.array(onSiteStructureSchema),
    documents: z.array(inspectionDocumentSchema)
}); });
export var facilityStructureSchema = z.lazy(function () { return z.object({
    structureId: z.string(),
    isLeaf: z.boolean(),
    structures: z.array(facilityStructureSchema),
    inspectionItemGroups: z.array(inspectionItemGroupSchema),
    name: z.string().optional()
}); });
export var reportSchema = z.object({
    url: z.string(),
    fileName: z.string(),
    documentId: z.string(),
    documentVersionId: z.string(),
    reportStatus: inspectionReportStatusSchema
});
export var inspectionSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    inspectionGroup: idNamePairSchema,
    inspectors: z.array(inspectorSchema),
    inspectedDate: z.string().nullable(),
    lastUpdated: z.string().nullable(),
    inspectionStatus: inspectionStatusSchema,
    properties: z.array(onSitePropertySchema),
    metadata: z.array(metadataSchema),
    inspectionDate: z.string().nullable(),
    isOverdue: z.boolean()
});
export var inspectionListSchema = z.array(inspectionSchema);
export var onSiteInspectionListItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    organizationId: z.string(),
    projectName: z.string(),
    status: z.string(),
    inspectionDate: z.string(),
    inspectionGroup: z.string(),
    inspectors: z.array(inspectorSchema),
    contentGroup: metadataSchema,
    isOverdue: z.boolean()
});
export var onSiteInspectionListSchema = z.array(onSiteInspectionListItemSchema);
//# sourceMappingURL=Inspection.zod.js.map